import React, { useEffect, useState } from 'react';
import Rodal from '../../../../components/Rodal/Rodal';
import { ModalBody, Col, Row } from 'reactstrap';
import { Field, Form, Input } from '@availity/form';
import './ManageSectionModal.scss';
import * as yup from 'yup';

interface ManageSectionModalProps {
    isVisible: boolean;
    onClose: () => void;
    mode: 'create' | 'edit';
    onAddSection: (sectionName: string) => Promise<boolean>;
    onUpdateSection?: (sectionId: string, name: string) => Promise<boolean>;
    initialSectionName?: string;
    rowId: string | null;
}

const ManageSectionModal = (props: ManageSectionModalProps) => {

    const [isSendingRequest, setIsSendingRequest] = useState(false);

    const validationSchema = yup.object().shape({
        sectionName: yup.string().trim().required()
    });

    const isEditMode = props.mode === 'edit';

    return (
        <div className="new-section-modal-container">
            <Rodal
                visible={props.isVisible}
                animation={'slideTop'}
                onClose={props.onClose}
                showMask={true}
                width={300}
                closeOnEsc
                className="new-section-modal"
                center>
                <ModalBody>
                    <div className="mt-4" style={{ width: '100%' }}>
                        <Form
                            initialValues={{sectionName: props.initialSectionName || '' }}
                            validationSchema={validationSchema}
                            enableReinitialize
                            onSubmit={() => {}}
                        >
                            {({values, resetForm, isValid, dirty}) => (
                                <>
                                    <Row>
                                        <Col md={12}>
                                            <Field
                                                name="sectionName"
                                                label={isEditMode ? "Edit section name:" : "Enter the name of the new section:"}
                                                placeholder="Name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col className="d-flex justify-content-between">
                                            <button
                                                disabled={isSendingRequest}
                                                className="btn btn-outline-secondary w-50 mr-2"
                                                onClick={() => {
                                                    props.onClose();
                                                    resetForm();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-50"
                                                disabled={!isValid || !dirty || isSendingRequest}
                                                onClick={async (e) => {
                                                    e.preventDefault();

                                                    if (isValid && dirty) {
                                                        setIsSendingRequest(true);

                                                        let isSuccessful = false;

                                                        if (isEditMode && props.onUpdateSection) {
                                                            isSuccessful = await props.onUpdateSection(props.rowId, values.sectionName);
                                                        } else {
                                                            isSuccessful = await props.onAddSection(values.sectionName);
                                                        }
                                                        
                                                        if (isSuccessful) {
                                                            props.onClose();
                                                            resetForm();
                                                        }

                                                        setIsSendingRequest(false);
                                                    }
                                                }}
                                            >
                                                {isEditMode ? 'Update' : 'Add'}
                                            </button>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Form>
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    )
};

export default ManageSectionModal;